export default __webpack_public_path__ + "assets/icons/support_title_bg.da962a79.svg";